import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../../assets/styles/themes/tokens';
import FilterChip from '../../modals/SearchFiltersDialog/FilterChip';

export interface Option {
	value: string;
	name: string;
	isSelected: boolean;
	iconName?: string;
}

interface OnboardingOptionChipListProps {
	options: Option[];
	onItemClick: (value: Option['value']) => void;
	isShowOrText?: boolean;
}

const OnboardingOptionChipList: React.FC<OnboardingOptionChipListProps> = ({
	options,
	onItemClick,
	isShowOrText = false,
}) => {
	const { t } = useTranslation();
	const handleClick = (value: string) => () => onItemClick(value);
	const optionsLength = options.length;

	return (
		<Box
			data-testid="option-chip-list"
			sx={{
				display: 'flex',
				gap: spaces.xs,
				flexWrap: 'wrap',
				justifyContent: 'center',
				overflow: 'hidden',
			}}
		>
			{options.map((option, index) => {
				const isSecondLastOption = index === optionsLength - 2;

				return (
					<React.Fragment key={`${option.value}-${index}`}>
						<Box data-testid={`option-chip-${option.value}`}>
							<FilterChip
								isSelected={option.isSelected}
								value={option.value}
								label={option.name}
								onClick={handleClick(option.value)}
							/>
						</Box>
						{isShowOrText && isSecondLastOption && (
							<Typography
								data-testid="or-text"
								variant="caption"
								color={palette.text.disabled}
								sx={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								{t('or')}
							</Typography>
						)}
					</React.Fragment>
				);
			})}
		</Box>
	);
};

export default OnboardingOptionChipList;
